// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"87404535","239":"4c1ddf3a","453":"867606b6","732":"8e44878b"}[chunkId] + ".chunk.js";
};